import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes"
import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType"

const initState = {
    groupName: ''
}

export const groupData = {
    name: "Group Form",
    initialState: initState,
    section: [
        {
            sectionId: 'groupForm',
            title: "Group Form",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-2 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "groupName",
                    label: "Group Name",
                    Field_Name: "Group name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "groupName",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Enter Your Group Name",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-text-model",
                    },
                }
            ]
        }
    ]
}